import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

const helpers = createMultiStyleConfigHelpers(["tag"]);

export const ChipConfig = helpers.defineMultiStyleConfig({
  baseStyle: defineStyle((props) => {
    const { ellipse } = props;
    return {
      tag: {
        padding: ellipse
          ? "0.25rem 1rem 0.25rem 0.5rem"
          : "0.563rem 1rem 0.438rem 1rem",
        borderRadius: "full",
        textStyle: "label.sm",
        fontWeight: 500,
        color: "gray.600",
      },
    };
  }),
  variants: {
    solid: defineStyle((props) => {
      const { colorScheme: theme } = props;
      return {
        tag: {
          backgroundColor: `${theme}.white`,
          color: "gray.600",
        },
      };
    }),
    outline: defineStyle((props) => {
      const { colorScheme: theme, isDimmed } = props;
      return {
        tag: {
          backgroundColor: "transparent",
          color: isDimmed ? "gray.500" : `${theme}.aubergine`,
          border: "1px solid",
          borderColor: isDimmed ? "gray.500" : `aubergine.300`,
        },
      };
    }),
    text: defineStyle((props) => {
      const { ellipse } = props;
      return {
        tag: {
          padding: ellipse ? "0.5rem 0" : "0.75rem 0",
          backgroundColor: "transparent",
        },
      };
    }),
  },
  defaultProps: {
    variant: "solid",
  },
});
